// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__kCaE5","title":"styles_title__jMeZi","text":"styles_text__oVQLW","container":"styles_container__yHkro"};